var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ActionButton',{attrs:{"title":_vm.$t('maintenance_detail.useful_docs'),"icon":"mdi-file-document","action":_vm.goDocuments}})
}
var staticRenderFns = []

export { render, staticRenderFns }